import type { FC } from 'react'
import { useState } from 'react'

import DocumentRequestsButton from '@/components/DocumentRequestsButton'
import type { SectionName } from '@/lib/apollo/query/get-document-requests'

import Sidebar from './Sidebar'
import type { RefereeDetails } from './utils/types'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  sectionName: SectionName
  subjectName: string
  isRefCompleted: boolean
  isCorporateTenantSubject?: boolean
  disabled?: boolean
  refereeDetails?: RefereeDetails
}

const DocumentRequests: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  sectionName,
  subjectName,
  isRefCompleted,
  isCorporateTenantSubject,
  disabled = false,
  refereeDetails,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <Sidebar
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          onClose={() => setIsSidebarOpen(false)}
          sectionName={sectionName}
          subjectName={subjectName}
          isCorporateTenantSubject={isCorporateTenantSubject ?? false}
          refereeDetails={refereeDetails}
        />
      )}
      <DocumentRequestsButton
        disabled={!isRefCompleted || disabled}
        onClick={() => setIsSidebarOpen(true)}
      />
    </>
  )
}

export default DocumentRequests
